import { Component, inject } from '@angular/core';
import { CommonModule } from "@angular/common";

import { DocMeta } from "@template-ui/decorators";
import { EzFormDialogService } from "@template-ui/services";
import { AppBaseComponent } from "@app/shared/components/app-base.component";
import { UiLibraryModule } from "@template-ui/template-ui.module";
import { SHOWCASE_LIBRARY_NAMES } from "../../showcase-library.constants";

@DocMeta({
  hide: true,
  showcaseAttachTo: [{ libName: SHOWCASE_LIBRARY_NAMES.BASE, classNames: ["EzFormDialogComponent"] }],
})
@Component({
  selector: 'ui-form-dialog-sample, ez-form-dialog-sample',
  imports: [CommonModule, UiLibraryModule],
  templateUrl: './ez-form-dialog-sample.component.html',
  styleUrls: ['./ez-form-dialog-sample.component.scss']
})
export class EzFormDialogSampleComponent extends AppBaseComponent {
  ezFormDialog = inject(EzFormDialogService);

  clemencyCaseId: number = 12345; // Example case ID

  addAssignmentRec() {
    // this.ezFormDialog.open(buildAssignmentDialogConfig(this.clemencyCaseId, this.apis))
    //   .pipe(this.takeUntilDestroyed())
    //   .subscribe(() => { });
  }

}


// export function buildAssignmentDialogConfig(
//   clemencyId: number,
//   apis: AppApis,
//   saveActionType: 'create' | 'update' = 'create',
//   existingRecord: any = null
// ): EzFormDialogData {
//   return buildClemencyDialogConfig({
//     entity: 'Assignment (Education, Jobs, Programs)',
//     parentId: clemencyId,
//     saveActionType,
//     existingRecord,
//     fields: [
//       { type: 'date', name: 'programAssignedDate', label: 'Assigned Date', row: 1, width: '1x', validation: [Validators.required] },
//       { type: 'number', name: 'jobPgmAssignmentLoc', label: 'Program Assignment Location', row: 1, width: '1x', validation: [Validators.required, Validators.minLength(1)] },
//       { type: 'text', name: 'workPgmAssignmentCode', label: 'Work Program Assignment Code', row: 1, width: '1x', validation: [Validators.required, Validators.minLength(1)] },
//       { type: 'text', name: 'workSquadSectionName', label: 'Squad Section Name', row: 1, width: '1x', validation: [Validators.required, Validators.minLength(1)] },
//       { type: 'text', name: 'asgnPositionNumber', label: 'Position #', row: 2, width: '1x', validation: [Validators.required, Validators.minLength(1)] },
//       { type: 'text', name: 'asgnPositionTitle', label: 'Position Title', row: 2, width: '1x', validation: [Validators.required, Validators.minLength(1)] },
//       { type: 'text', name: 'jobPgmAssignmentStatus', label: 'Status', row: 2, width: '1x', validation: [Validators.required, Validators.minLength(1)] },
//       { type: 'date', name: 'statusDate', label: 'As of date', row: 2, width: '1x', validation: [Validators.required, Validators.minLength(1)] },
//     ],
//     saveEndpoint: "",
//   });
// }
